import { render } from "./SessionList.vue?vue&type=template&id=24d9f4b2"
import script from "./SessionList.vue?vue&type=script&lang=js"
export * from "./SessionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__